<template>
  <div class="login container">
    <v-layout row wrap>
      <v-flex d-flex py-5>
        <v-card class="pa-2" @keyup.enter="login" v-if="!forgotPassword">
          <v-card-title>
            <h2>Login</h2>
          </v-card-title>
          <v-card-text>
            <v-form ref="Login" @submit.prevent="login">
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Email"
                required
              ></v-text-field>
              <v-text-field
                :append-icon="show1 ? 'visibility_off' : 'visibility'"
                :type="show1 ? 'text' : 'password'"
                v-model="password"
                label="Password"
                @click:append="show1 = !show1"
                required
              ></v-text-field>
              <p class="red-text" v-if="feedback">{{ feedback }}</p>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn flat color="info" @click="forgotPassword = true"
              >Forgot Password?</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn @click="login">Login</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="pa-2" v-else>
          <v-card-title>
            <h2>Forgot Password</h2>
          </v-card-title>
          <v-card-text>
            <p>
              To reset your password, enter the email address associated to the
              login account.
            </p>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="Email"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn flat color="info" @click="forgotPassword = false"
              ><v-icon class="mr-2">fa-caret-left</v-icon>Return To Login</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              @click="sendResetEmail"
              :loading="loadingRequest"
              :disabled="loadingRequest"
              >Send Password Reset Email</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-snackbar v-model="snackbar" :color="response.status" top>
          {{ response.msg }}
        </v-snackbar>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
      feedback: null,
      show1: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      forgotPassword: false,
      loadingRequest: false,
      snackbar: false,
      response: { msg: "", color: "success" },
    };
  },
  methods: {
    login() {
      if (this.email && this.password) {
        this.loadingRequest = true;
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then((cred) => {
            this.loadingRequest = false;
            this.$router.push({ name: "home" });
          })
          .catch((err) => {
            this.loadingRequest = false;
            this.feedback = err.message;
          });
        this.feedback = null;
      } else {
        this.feedback = "Please fill in both fields";
      }
    },
    sendResetEmail() {
      let baseURL = window.location.hostname;
      let baseProtocol = window.location.protocol;
      let userEmail = this.email.trim();

      this.loadingRequest = true;

      axios
        .post(`${baseProtocol}//${baseURL}/users_api/sendPasswordResetEmail`, {
          email: userEmail,
        })
        .then((passwordResetResult) => {
          this.response = { msg: passwordResetResult.data, status: "success" };
        })
        .catch((passwordResetError) => {
          this.response = { msg: passwordResetError, status: "error" };
        })
        .finally(() => {
          this.forgotPassword = false;
          this.snackbar = true;
          this.loadingRequest = false;
        });
    },
  },
  created() {
    this.$store.commit("RESET_STORE");
  },
};
</script>

<style scoped>
.login {
  width: 40%;
}
.red-text {
  color: red;
}
</style>
